import React from 'react';

import { TEXTS } from 'application/pages/AdsPage/renderer/texts';
import { DAYS_TEXTS } from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import Chip from '@zvuk-b2b/react-uikit/ui/Chip';

import { Days, WeekDaysType } from '@zvuk-b2b/react-uikit/toolkit/DateUtils/types';
import styles from './index.module.scss';

type TimingSettingsProps = {
  days: WeekDaysType;
  isLoading: boolean;
  handleDay: (key: string, value: boolean) => void;
};

const WeekdaysSettings = ({ handleDay, days, isLoading }: TimingSettingsProps) => {
  const onChange = (key: string, value: boolean) => {
    handleDay(key, value);
  };

  return (
    <div>
      <h4>{TEXTS.AD_TIMING_SETTING_TITLE}</h4>

      <div className={styles.TimingSettings}>
        {Object.entries(days).map(([key, value]) => (
          <div
            key={`div_chip_timing_settings_${key}`}
            className={styles.TimingSettingsChipContainer}>
            <Chip
              className={styles.TimingSettingsChip}
              elementId={`chip_timing_settings_${key}`}
              isActive={value}
              isDisabled={isLoading}
              isClickable
              onClick={(value: boolean) => onChange(key, value)}>
              {DAYS_TEXTS[key as Days]}
            </Chip>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeekdaysSettings;
